export default "__VITE_ASSET__C3BKZ$dm__"